import React, { useState } from "react";

import { useLocation } from "react-router-dom";

import TagMeetingHeader from "../components/TagMeetingHeader";
import MarkMyDayForm from "../components/MarkMyDayForm";
import ThankYouComponent from "../components/ThankYouComponent";

const MarkMyDayPage = () => {
  const location = useLocation();
  const date = location.state;
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <>
      <TagMeetingHeader headerName="Mark my day" />
      {showSuccess ? (
        <ThankYouComponent message="Done! Your meeting is set for the day." />
      ) : (
        <MarkMyDayForm date={date} setShowSuccess={setShowSuccess} />
      )}
    </>
  );
};

export default MarkMyDayPage;
